import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../components/PageLoader";
import { selectDbnpProductListItems } from "../../../../../../redux/dbn-cloud/dbnp-products/selector";
import { dbnpProducts } from "../../../../../../redux/dbn-cloud/dbnp-products/action";

const DBNDomainProductMappings = ({ selectedDBNDomain }) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [searchCriteriaList, setSerchCriteriaList] = useState<any>([]);
  const dbnDomainProductMappingsListData = useSelector(selectDbnpProductListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'MediaMappings.MediaFiles[0].FileMappingURL',
        headerName: 'Image',
        sortable: false,
        filter: false,
        cellRenderer: 'imageRenderer',
        filterType: 'text',
        callback: handleEditProduct,
      },
      {
        field: 'ProductCode',
        headerName: 'Product Code',
        // searchField: 'ProductCode',
        sortable: true,
        filter: true,
        filterType: 'text',
        align: 'text-left'
      },
      {
        field: 'Name',
        headerName: 'Name',
        // searchField: 'Name',
        sortable: true,
        filter: true,
        filterType: 'text',
        callback: handleEditProduct,
        align: 'text-left'
      },
      {
        field: 'EdgeDBNDomainCode',
        headerName: 'Edge DBN Domain Code',
        searchField: 'EdgeDBNDomainCode',
        sortable: true,
        filter: true,
        filterType: 'text',
        align: 'text-left'
      },
      { field: 'EdgeDBNDomainName', headerName: 'Edge DBN Domain Name', searchField: 'EdgeDBNDomainName', sortable: true, filter: true, filterType: 'text' },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleEditProduct = (data: any) => {
    console.log(data,'data')
    navigate(`/management/catalog/products/${data?.ProductId}`)
  }

  const fetchProductsList = () => {
    dispatch(dbnpProducts.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/products/fetch`,
      entity: 'products',
      jsonData:
      {
        Context: {},
        Records: [
          {
            EdgeDBNDomainCode: selectedDBNDomain?.Code
          }
        ],
        Pagination: {
          PageNumber: pageData,
          PageSize: pageSize,
          SortField: "CreatedOnUtc",
          SortOrder: "desc",
          Searches: searchCriteriaList || undefined,
        }
      }
    }))
  }

  const handleReloadData = () => {
    fetchProductsList();
  }

  const handleSearch = (data: any) => {
    let searchCriteria = [];
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "EdgeDBNDomainName",
        FieldText: "EdgeDBNDomainName",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    setSerchCriteriaList(searchCriteria)
    fetchProductsList();
  }

  useEffect(() => {
    createColumnDefs();
    fetchProductsList();
  }, [pageData, pageSize, searchCriteriaList])

  return (
    <>
      {dbnDomainProductMappingsListData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={dbnDomainProductMappingsListData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          searchCriteriaList={searchCriteriaList}
          paginationData={dbnDomainProductMappingsListData?.result?.pagination}
          enableFilter={true} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'ProductId',
          }}
          additionButtons={additionButtons}
          headingName="Domain Product Mappings"
        />
      }
    </>
  );
};

export default DBNDomainProductMappings;